import { TEMPLATE_GALLERY } from '@confluence/named-routes/entry-points/routes.ts';

const TEMPLATE_GALLERY_TAB_BLOCK = 'block';

export const getSnippetShareUrl = (shareId: string, snippetId: string): string => {
	return TEMPLATE_GALLERY.toUrl(
		{},
		{ query: { tab: TEMPLATE_GALLERY_TAB_BLOCK, shareId, snippetId } },
	);
};
